// extracted by mini-css-extract-plugin
export default {"ball-clip-rotate":"styles_ball-clip-rotate__Qemvo","rotate":"styles_rotate__scoRF"};